import React from 'react';
import { AdminTabType } from '../types';
import { TabNavigation, TabButton, TabIcon } from './styled';

interface AdminTabNavigationProps {
  activeTab: AdminTabType;
  onTabChange: (tab: AdminTabType) => void;
}

// Move static tabs array outside component to avoid recreation on each render
const tabs = [
  {
    id: 'credits' as AdminTabType,
    label: 'Manage Credits',
    icon: '💎'
  },
  {
    id: 'users' as AdminTabType,
    label: 'Manage Users',
    icon: '👥'
  }
];

const AdminTabNavigation: React.FC<AdminTabNavigationProps> = ({
  activeTab,
  onTabChange
}) => {
  return (
    <TabNavigation>
      {tabs.map((tab) => (
        <TabButton
          key={tab.id}
          $active={activeTab === tab.id}
          onClick={() => onTabChange(tab.id)}
        >
          <TabIcon>{tab.icon}</TabIcon>
          {tab.label}
        </TabButton>
      ))}
    </TabNavigation>
  );
};

export default AdminTabNavigation;
